import React from "react";
import '../../resources/styles/loadingStyle.css';
/*****************************************************************************
 * REVISION 1.0
 * Fecha: 01/11/2020
 *
 * @description componente para manejo de cargando en la app
 * @author lferrer
 * @version 1.0
 *
 ****************************************************************************/
const Loading = props => (
  <>
    <div className="container">
        <div className="row">  
            <div className="animationload">
                <div className="osahanloading"></div>
            </div>
        </div>
    </div>
  </>
);
export default Loading;
